export default [
    {
      path: '/admin/stock-counts',
      name: 'stock-count',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-count/index.vue')
    },
    {
      path: '/admin/stock-counts/create',
      name: 'stock-count-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-count/create.vue')
    },
    {
      path: '/admin/stock-counts/:id/edit',
      name: 'stock-count-edit',
      meta: { requiresAuth: true },
      component: () => import('@/pages/stock/stock-count/edit.vue')
    }
  ]
  